import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { catchError, map, Observable, throwError } from 'rxjs';
import { ApiLoadingService } from "./api-loading.service";

@Injectable()
export class ApiCommunicationInterceptor implements HttpInterceptor {

  constructor(private _apiLoading: ApiLoadingService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    if (request.url.indexOf('/api') != -1) {
      this._apiLoading.addInProgress();
    }

    return next.handle(request)
      .pipe(map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          if (event.url?.indexOf('/api') != -1) {
            this._apiLoading.decrementInProgress();
          }
        }
        return event;
      }),
        catchError((error: HttpErrorResponse) => {
          this._apiLoading.decrementInProgress();
          return throwError(error);
        })
      );
  }
}
